import CompLottieAnimation from "@@/lottieAnimation.vue";
import { getOrderNeedPacks, postOpenPacks } from '@/api/index';
import lowerdev from "@/service/lowerdev";
import MDRouter from "@/service/router";
import env from "md-base-tools/env";
export default {
  name: 'unboxing',
  components: {
    CompLottieAnimation
  },
  data() {
    return {
      countdown: 0,
      timer: null,
      resultTimer: null,
      pack_status: 0,
      // 0=未拆盒，1=已拆盒
      // 未拆盒信息
      unpackInfo: {
        show_title: '',
        show_img: '',
        num: 0,
        pack_time: 120
      },
      // 已拆盒信息
      packSuccessInfos: [],
      // URL 参数
      orderId: '',
      loading: true,
      // 控制大图展示/列表展示
      showResultWrapper: true,
      // 控制按钮显示（多盒时延迟显示）
      showButtons: false,
      miniProgram: ""
    };
  },
  computed: {
    // 获取第一个隐藏款（unpacking_type_name 不为空）
    hiddenItem() {
      return this.packSuccessInfos.find(item => item.unpacking_type_name && item.unpacking_type_name.trim() !== '');
    },
    // 判断是否有隐藏款
    hasHiddenItem() {
      return !!this.hiddenItem;
    },
    // 大图展示的物品：单个盲盒显示第一个，多盒显示隐藏款
    displayItem() {
      if (this.packSuccessInfos.length === 1) {
        return this.packSuccessInfos[0];
      }
      return this.hiddenItem;
    },
    // 合并相同名称的物品，统计数量
    mergedPackList() {
      if (!this.packSuccessInfos || this.packSuccessInfos.length === 0) {
        return [];
      }

      // 按 unpacking_name 分组统计
      const mergedMap = new Map();
      this.packSuccessInfos.forEach(item => {
        const key = item.unpacking_name;
        if (mergedMap.has(key)) {
          // 已存在，数量+1
          const existing = mergedMap.get(key);
          existing.count += 1;
        } else {
          // 不存在，新增
          mergedMap.set(key, {
            ...item,
            count: 1
          });
        }
      });

      // 转换为数组返回
      return Array.from(mergedMap.values());
    }
  },
  created() {
    // 提前在 created 钩子中发起请求
    this.initPage();
  },
  beforeMount() {
    if (sessionStorage.getItem("miniProgram") === "weixin") {
      lowerdev.dynamicScript("https://res.wx.qq.com/open/js/jweixin-1.4.0.js");
    }
  },
  mounted() {
    // eslint-disable-next-line eqeqeq
    this.miniProgram = sessionStorage.getItem("miniProgram") == "weixin";
  },
  beforeUnmount() {
    this.clearTimer();
    this.clearResultTimer();
  },
  methods: {
    // 初始化页面
    async initPage() {
      // 获取 URL 参数
      const query = this.$route.query;
      this.orderId = query.order_id || '';
      if (!this.orderId) {
        console.error('缺少 order_id 参数');
        return;
      }

      // 请求数据
      await this.fetchOrderNeedPacks();
    },
    // 获取盲盒数据
    async fetchOrderNeedPacks() {
      try {
        this.loading = true;
        const params = {
          order_id: this.orderId
        };
        const res = await getOrderNeedPacks(params);
        if (res.status === 0 && res.data) {
          const {
            pack_status,
            unpack_info,
            pack_success_infos
          } = res.data;
          this.pack_status = pack_status;
          if (pack_status === 0) {
            // 未拆盒状态
            this.unpackInfo = unpack_info || {};
            this.countdown = unpack_info === null || unpack_info === void 0 ? void 0 : unpack_info.pack_time;
            if (this.countdown > 0) {
              this.startCountdown();
            } else {
              this.autoUnbox();
            }
          } else if (pack_status === 1) {
            // 已拆盒状态（页面初始化时已拆盒，直接展示结果）
            this.packSuccessInfos = pack_success_infos || [];

            // 单个盲盒：显示大图
            if (pack_success_infos && pack_success_infos.length === 1) {
              this.showResultWrapper = true;
            }
            // 多个盲盒：直接显示列表（页面已经加载过了，不展示动画）
            else {
              this.showResultWrapper = false;
            }

            // 立即显示按钮
            this.showButtons = true;
          }
        }
      } catch (error) {
        console.error('获取盲盒数据失败:', error);
      } finally {
        this.loading = false;
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          // 当倒计时减到 0 时，立即执行拆盒
          if (this.countdown === 0) {
            this.clearTimer();
            this.autoUnbox();
          }
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    clearResultTimer() {
      if (this.resultTimer) {
        clearTimeout(this.resultTimer);
        this.resultTimer = null;
      }
    },
    async handleUnbox() {
      // 点击立即拆盒
      this.clearTimer();
      console.log('手动拆盒');
      await this.openPacks();
    },
    async autoUnbox() {
      // 倒计时结束，自动拆盒
      console.log('自动拆盒');
      await this.openPacks();
    },
    // 调用拆盒接口
    async openPacks() {
      try {
        const params = {
          order_id: this.orderId
        };
        const res = await postOpenPacks(params);
        if (res.status === 0 && res.data) {
          const {
            pack_status,
            pack_success_infos
          } = res.data;

          // 使用接口返回的状态
          this.pack_status = pack_status;
          this.packSuccessInfos = pack_success_infos || [];

          // 只有拆盒成功（pack_status === 1）才显示结果
          if (pack_status === 1) {
            // 单个盲盒：保持原有逻辑，直接显示大图
            if (pack_success_infos && pack_success_infos.length === 1) {
              this.showResultWrapper = true;
              this.showButtons = true;
            }
            // 多个盲盒：判断是否有隐藏款
            else if (pack_success_infos && pack_success_infos.length > 1) {
              // 判断是否有隐藏款
              const hasHidden = pack_success_infos.some(item => item.unpacking_type_name && item.unpacking_type_name.trim() !== '');
              if (hasHidden) {
                // 有隐藏款：显示大图（隐藏款），3秒后切换到列表
                this.showResultWrapper = true;
                this.clearResultTimer();
                this.resultTimer = setTimeout(() => {
                  this.showResultWrapper = false;
                  this.showButtons = true;
                }, 3000);
              } else {
                // 没有隐藏款：直接显示列表
                this.showResultWrapper = false;
                this.showButtons = true;
              }
            }
          }
        }
      } catch (error) {
        console.error('拆盒失败:', error);
      }
    },
    handleViewOrder() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "onGetUserInfo",
        functionParams: {},
        callBack: e => {
          if (Number(e.data.build) > 62511251) {
            //支持Redirect跳转至订单详情页
            MDRouter.redirectProOrderDetail(this.orderId);
          } else {
            //不支持Redirect跳转至订单详情页
            MDRouter.goProOrderDetail(this.orderId);
          }
        },
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            MDRouter.MinaRouter('ProOrder', {
              id: this.orderId
            });
          } else {
            MDRouter.goProOrderDetail(this.orderId);
          }
        }
      });
    },
    handleClose() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "closeController",
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateBack();
          } else {
            history.back();
          }
        }
      });
    }
  }
};